import {createStore, applyMiddleware, compose} from 'redux';
import {
  persistStore,
  persistReducer,
  createMigrate,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';
import {reducer as rootReducer} from './actions';
import apiMiddleware from './middleware/apiMiddleware';

const migrations = {
  1: (state) => {
    return undefined;
  },
}

const persistConfig = {
  key: 'root',
  storage: storage,
  blacklist: ['req'],
  version: 1,
  migrate: createMigrate(migrations, {debug: false}),
}

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Note: this API requires redux@>=3.1.0
const makeStoreAndPersistor = () => {
  const store =createStore(
    persistedReducer,
    compose(
      applyMiddleware(
        thunk,
        apiMiddleware,
      )
    )
  );

  const persistor = persistStore(store);
  return {store, persistor};
}

const {store, persistor} = makeStoreAndPersistor();
export {persistor};
export default store;



// WEBPACK FOOTER //
// ./src/store.js